import React from 'react';

export const ColorPicker = () => {
  return <div>ColorPicker</div>;
};
